import { CoercionError } from "@/domains/errors";
import { DateTime, DateTimeOptions } from "luxon";

export const toIsoWithOffset = (value: DateTime): string => {
  if (!value.isValid) {
    throw new CoercionError({
      message: `[toIsoWithOffset]: invalid DateTime - ${value.invalidReason}`,
    });
  }
  const iso = value.toISO();
  if (iso === null) {
    throw new CoercionError({ message: `[toIsoWithOffset]: toISO returned null` });
  }
  return iso;
};

export const dayAtLocalNoonIso = (
  { year, month, day }: { year: number; month: number; day: number },
  options?: DateTimeOptions
): string => {
  const dt = DateTime.fromObject({ year, month, day, hour: 12, minute: 0, second: 0 }, options);
  return toIsoWithOffset(dt);
};
